import ScrollAnimationWrapper from '../helpers/ScrollAnimationWrapper'
import GradientBorder from '../GradienentBorder'
import { Container } from './styles'

interface DescriptionBlockProps {
  text?: string
  strong?: string
  bgColor?: string
}

export function DescriptionBlock({
  strong,
  text,
  bgColor = '#CB8F55',
}: DescriptionBlockProps) {
  return (
    <ScrollAnimationWrapper animateIn="animate__fadeInLeft">
      <Container bgColor={bgColor}>
        <p>
          <strong>{strong}</strong>
        </p>
        <p>{text}</p>
      </Container>
    </ScrollAnimationWrapper>
  )
}

